import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import TextField from "@plugins/text-field/text-field";

import './login-form-style.scss';

@Component
export default class LoginForm extends Vue {

  @Prop({ required: true }) loginFormData;


  validationResult = {
    username: {},
    password: {},
  };
  loginUser = {
    username: '',
    password: '',
  };

  onTextFieldValueChange(name, value) {
    this.loginUser[name] = value;
  }

  onValidated(name, value) {
    this.validationResult[name] = value;
  }
  onKeyUp(event) {
    if (event && event.keyCode == 13) {
      this.onLoginClick();
    }
  }

  get isFormValid() {
    return Object.values(this.validationResult).every(e => e.valid);
  }
  onLoginClick() {
    if (this.isFormValid) {
      this.$emit('change', this.loginUser);
    }
  }

  render(h) {
    return (
      <div class="login-form">
        <div class="form-group">
          <TextField
            id={'username'}
            required={true}
            value={this.loginUser.username}
            {...{ attrs: this.textFieldConfig }}
            placeholder={'Username'}
            onValuechanged={this.onTextFieldValueChange}
            onValidated={this.onValidated}
            onKeyup={this.onKeyUp}
          ></TextField>
          <TextField
            id={'password'}
            required={true}
            password={true}
            value={this.loginUser.password}
            {...{ attrs: this.textFieldConfig }}
            placeholder={'Password'}
            onValuechanged={this.onTextFieldValueChange}
            onValidated={this.onValidated}
            onKeyup={this.onKeyUp}
          ></TextField>
        </div>
        <button class={`dt-button v1 s2 ${this.isFormValid ? '' : 'disabled'} `} disabled={!this.isFormValid} onClick={this.onLoginClick} >
          {this.loginFormData.authenticated ? 'Logged In'
            : this.loginFormData.authenticating ? <img src="static/icons/loading.gif" alt="" />
              : 'Login'
          }
        </button>
        <div style={{
          backgroundColor: `var(--bittersweet)`,
          padding: `8px`,
          borderRadius: `8px`,
          margin: `6px`,
          textAlign: `center`,

          transition: '150ms ease-out',
          transform: this.loginFormData.invalidLogin ? `translateY(0px)` : 'translateY(20px)',
          opacity: this.loginFormData.invalidLogin ? 1 : 0,
        }} class={`error`}>
          Username and password does not match
        </div>
      </div>
    )
  }
}


